import React, {useState, useEffect, useMemo, useRef} from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import { useTable, useExpanded } from "react-table";

import '../../styles/style.scss';

import usersService from "../../services/users.service";
import { actionErrorConnection } from '../../constants/component/actionErrorConnection';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { sesionExpired } from '../../constants/auth/sesionExpired';
import { useDispatch, } from 'react-redux';
import { Tooltip } from '@material-ui/core';
import { ADMINISTRADOR } from '../../constants/models/typeOperationRol';
import { useAuthInfo } from '../../utils/authUtils';

export const UsersScreen = (props) => {

  const { noCustomer, operationRol } = useAuthInfo()
  const dispatch = useDispatch();
  const history = useHistory();

  const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
  const sessionDifference = timeSessionDifference();

  const [users, setUsers] = useState([]);
  const usersRef = useRef();

  const [isLoadingData, setIsLoadingData] = useState(false);

  const [errorResponse, setErrorResponse] = useState('');
  const [isErrorResponse, setIsErrorResponse] = useState(false);
  const[userState, setUserState] = useState(null);
  usersRef.current = users;
  const editCustomer= (rowIndex) => {
    const id = usersRef.current[rowIndex].id;
    history.push({
      pathname: `/administration/users/update/${id}`,
      state: {
        customer: usersRef.current[rowIndex]
      }
    });
    window.location.reload();
  };
  
  const getUsers = () => {
    setUsers([]);
    setIsLoadingData(true);
    usersService.getManagersByAN8(noCustomer)
      .then((response) => {
        setIsLoadingData(false);
        setUsers(response);
        setIsErrorResponse(false);
      })
      .catch((error) => {
        console.log(error)
        setIsLoadingData(false);
        setUsers([]);
        setIsErrorResponse(true);
        if(error.response){
          setErrorResponse(error?.response.data.state || error.message);
          if(sessionDifference > Number(tokenExpired)){
            sesionExpired(dispatch, history);
          }
        } else{
          setErrorResponse(error);
          actionErrorConnection(error);
        }
      });
  };

  useEffect(() =>{
    getUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: 'Número',
        accessor: 'noCustomer'
      },
      {
        Header: 'Nombre',
        accessor: 'name'
      },
      {
        Header: 'Correo',
        accessor: 'mail'
      },
      {
        Header: "Rol",
        accessor: "operationRol"
      },
      {
        Header: 'Estado',
        accessor: 'status'
      },
      {
        Header: "Acciones",
        accessor: "actions",
        Cell: (propsCells) => {
          const rowIdx = propsCells.row.id;
            const onChangeUserStatus = (rowIndex) =>{

              const userData = usersRef.current[rowIndex];

              updateCustomerStatus(userData)
              
            }

          
          return (
            <div className={`${operationRol === ADMINISTRADOR ? 'd-inline' : 'd-none'}`}>
              <Tooltip title={propsCells.row.values.operationRol === ADMINISTRADOR && userState ? 'El administrador no puede ser deshabilitado' : (userState ? "Deshabilitar ": "Habilitar")} placement="top-start" arrow>
                <button 
                  className="btn custom-btn-icons" 
                  onClick={() => onChangeUserStatus(rowIdx)}
                  disabled={ propsCells.row.values.operationRol === ADMINISTRADOR && userState}
                >
                  <i className={`${userState ? 'fas fa-toggle-on' : 'fas fa-toggle-off'} action mr-2`}></i>
                </button>
              </Tooltip>
              <Tooltip title="Editar" placement="top-start" arrow>
                <button className="btn custom-btn-icons" onClick={() => editCustomer(rowIdx)}>
                  <i className="far fa-edit action mr-2"></i>
              </button>
              </Tooltip>
            </div>
          );
        },
      }
    ],// eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const updateCustomerStatus = (userData) =>{
        usersService
          .updateCustomerStatus(userData.id, !userData.status)
          .then(() => {
            setUserState(!userState);
            setIsLoadingData(false);
            window.location.reload();
          })
          .catch((error) => {
            console.log(error);
            setIsLoadingData(false);
            setIsErrorResponse(true);
            if (error.response) {
              setErrorResponse(error.response.data.mensaje);
              if (sessionDifference > Number(tokenExpired)) {
                sesionExpired(dispatch, history);
              }
            } else {
              setErrorResponse(error);
              actionErrorConnection(error);
            }
          });
  }
  const getNewCustomer = () => {
    props.history.push('/administration/users/create');
    window.location.reload();
  }

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data: users,
  },
  useExpanded);

    return (
        <>
          <div className="container-fluid p-0 m-0">
            <div className="row flex-nowrap p-0 m-0">
                <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                <SidebarMenu/>
                </div>
                <div className="col p-0 ms-1 me-1">
                <NavTopMenu />
                <div className="container ps-3 pe-3 container-size">
                  <div className="row base-container ">
                    <div>
                    <div className="col-12 border-title text-title pt-2 pb-2 ps-4">
                      <span className="h4">Representantes registrados</span>
                    </div>
                  
                    <div className="col-12 pt-3 pb-3 ps-1 pe-1">
                        <div className="row ">
                            <div className="container p-0">
                              <div className="row m-0">
                                <div className="col-12">
                                <div className={`w-100 d-flex justify-content-end
                                ${operationRol === ADMINISTRADOR ? 'd-inline' : 'd-none'}`}>
                                  <Tooltip title="Agregar" placement="top-start" arrow>
                                    <button className="btn custom-btn-icons" 
                                    type="button" 
                                    onClick={getNewCustomer}>
                                      <i className="fas fa-plus-square custom-icon-add"></i>
                                    </button>
                                  </Tooltip>
                                </div>
                                   <table
                                    {...getTableProps()}
                                  >
                                    <thead>
                                      {headerGroups.map((headerGroupUsers) => (
                                        <tr {...headerGroupUsers.getHeaderGroupProps()} className="border-content " key={`${headerGroupUsers?.id}-header-group`}>
                                          {headerGroupUsers.headers.map((column) => (
                                            <th {...column.getHeaderProps()}
                                            className="border-element header-element header-text pt-3 pb-3" key={`${column?.id}-headerColumn-group`}>
                                              {column.render("Header")}
                                            </th>
                                          ))}
                                        </tr>
                                      ))}
                                    </thead>
                                    <tbody {...getTableBodyProps()}>
                                      {rows.map((rowUsers) => {
                                        prepareRow(rowUsers);
                                        return (
                                          <React.Fragment key={rowUsers.getRowProps().key}>
                                          <tr className="element-row border-content">
                                            {rowUsers.cells.map((cell) => {
                                              return (
                                                <td className="border-element content-text pt-2 pb-2"
                                                {...cell.getCellProps()}
                                                key={`${cell?.id}-cellProps-td-${Math.random()}-${Math.random()}`}>
                                                  {
                                                    cell.column.id === 'status' ? 
                                                    (cell.value ? 'Activo' : 'inactivo')
                                                    : cell.render("Cell")
                                                  }
                                                </td>
                                              );
                                            })}
                                          </tr>
                                          </React.Fragment>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                  {(isErrorResponse) &&
                                    <div className="error-message border-content pt-4 pb-4">
                                      <span className="">{errorResponse?.toString()}</span>
                                    </div>}
                                  {(isLoadingData) &&
                                    <div className="element-row border-content pt-4 pb-4 custom-icon-loading">
                                      <i className="fas fa-spinner fa-spin"></i>
                                    </div>}
                                    {(users.length === 0 && !isLoadingData && !isErrorResponse) &&
                                      <div className="element-row-message border-content pt-4 pb-4 ">
                                        <span>No se recuperaron coincidencias.</span>
                                      </div>
                                    }  
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    </div>
                  </div>
                </div>
                </div>
            </div>
          </div>
            <Footer/>
        </>
    )
}

UsersScreen.propTypes = {
  row: PropTypes.any,
  getToggleAllRowsSelectedProps : PropTypes.any,
  history: PropTypes.object
};

